import { Grid, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import cx from 'classnames';
import useInput from 'lib/hooks/useInput';
import useMultiFileInput from 'lib/hooks/useMultiFileInput';
import CustomSpan from 'components/common/text/CustomSpan';
import SupportListRow from 'components/support/SupportListRow';
import MuiButton from 'components/common/button/MuiButton';
import MuiWrapper from 'components/common/input/MuiWrapper';
import T from 'components/common/text/T';
import MuiPagination from 'components/common/pagination/MuiPagination';
import { StyledNoneShadowButtonOuter } from 'components/common/styled/Button';
import { SupportActions, AppActions, FileActions } from 'store/actionCreators';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { useShallowAppSelector } from 'store/hooks';
import useCheckSetInput from 'lib/hooks/useCheckSetInput';
import { useDidUpdateEffect } from 'lib/utils';
import _ from 'lodash';
import { axs } from 'api/config/axiosConfig';
import * as fileApi from 'api/file';
import { CircularProgress } from '@material-ui/core';
import { downloadFile } from 'store/utils';
import axios, { Method } from 'axios';
import PageTitle from 'components/base/title/PageTitle';
import { useTranslation } from 'react-i18next';
import CustomPagination from 'components/common/pagination/CustomPagination';

interface IFaqPaging {
  page: number;
  totalPage: number;
}

function SupportContainer() {
  const {
    language,
    fetchFaqList,
    fetchFaqListSuccess,
    fetchFaqDetail,
    fetchFaqDetailSuccess,
    fetchQnaList,
    fetchQnaListSuccess,
    updateQna,
    updateQnaSuccess,
    fetchQnaDetail,
    fetchQnaDetailSuccess,
    completeUpdateQnaSuccess,
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    fetchFaqList: state.support.faqList.data || {},
    fetchFaqListSuccess: state.support.faqList.success,
    fetchFaqDetail: state.support.faqDetail.data || {},
    fetchFaqDetailSuccess: state.support.faqDetail.success,
    fetchQnaList: state.support.qnaList.data,
    fetchQnaListSuccess: state.support.qnaList.success,
    updateQna: state.support.updateQna.data,
    updateQnaSuccess: state.support.updateQna.success,
    fetchQnaDetail: state.support.qnaDetail.data,
    fetchQnaDetailSuccess: state.support.qnaDetail.success,
    // completeUpdateQna:state.support.completeUpdateQna.data,
    completeUpdateQnaSuccess: state.support.completeUpdateQna.success,
  }));

  const history = useHistory();

  const faqList = fetchFaqList?.list;
  const faqPagingData: IFaqPaging = fetchFaqList?.pagingData;
  const faqDetail = fetchFaqDetail?.faqInfo;
  const faqPage = useInput(1);
  const faqListPage = {
    totalPage: 16,
  };
  const { t } = useTranslation();
  const qnaList = fetchQnaList?.list;
  const qnaPagingData = fetchQnaList?.pagingData;
  const qnaDetail = fetchQnaDetail?.qnaInfo;
  const qnaPage = useInput(1);
  const updateQnaIdx = updateQna?.qnaInfo.qnaIdx;

  const page = useInput(1);
  // const faqPagingData = fetchEmployeeList?.pagingData;
  const [mySupportTab, setMySupportTab] = useState(0);
  const qnaFileRef = useRef<null | any>(null);
  const localFileList = useMultiFileInput([]);
  // const [isSubmit, setIsSubmit] = useState(false);
  // const [expand, setExpand] = useState(true);
  const isExpand = useInput(true);
  const requestTitle = useInput('');
  const requestContent = useInput('');

  const [qnaIdx, setQnaIdx] = useState<number | null>();
  const qnaExpandList = useCheckSetInput(new Set([]));
  const [qnaExpandListData, setQnaExpandListData] = useState<object[]>([]);
  const [uploadFileSuccessList, setUploadFileSuccessList] = useState<number[]>([]);
  const [uploadSuccessIndexList, setUploadSuccessIndexList] = useState<number[]>([]);
  const [uploadAbleFileLength, setUploadAbleFileLength] = useState<number>(0);
  const [isLast, setIsLast] = useState<boolean>(false);
  const [isFinishUploadLength, setIsFinishUploadLength] = useState<number>(0);
  // const qnaExpandListData = useCheckSetInput(new Set([]));

  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const [faqIdx, setFaqIdx] = useState<number | null>();
  const faqExpandList = useCheckSetInput(new Set([]));
  // const fnqExpandListData = useCheckSetInput(new Set([]));
  const [faqExpandListData, setFaqExpandListData] = useState<object[]>([]);

  const supportTabList = [
    {
      idx: 0,
      type: 'faq',
      title: 'FAQ',
    },
    {
      idx: 1,
      type: 'qna',
      title: '1:1 QnA',
    },
  ];

  const handleExpandData = (item: object | any, type: string | null) => {
    // qna/faq 디테일 확인했으면 해당 obj를 state에 보관
    // expand될 때마다 API통신 불필요, 재로딩 안하게끔 idx로 체크
    if (type === 'qna' && !qnaExpandList.value.has(item.qnaIdx)) {
      setQnaIdx(item.qnaIdx);
      SupportActions.fetch_qna_detail_request(item.qnaIdx);
    }
    if (type === 'faq' && !faqExpandList.value.has(item.faqIdx)) {
      setFaqIdx(item.faqIdx);
      // SupportActions.fetch_faq_detail_request(item.faqIdx);
    }
  };

  useDidUpdateEffect(() => {
    if (fetchFaqDetailSuccess) {
      // console.log('faqDetail _____ ', faqDetail, ' ---------- [ ', faqIdx);
      faqExpandList.onChange({ value: faqIdx });
      setFaqExpandListData(draft => [...draft, faqDetail]);
    }
  }, [fetchFaqDetailSuccess]);

  useDidUpdateEffect(() => {
    if (fetchQnaDetailSuccess) {
      // console.log('qnaDetail _____ ', qnaDetail, ' ---------- [ ', qnaIdx);
      qnaExpandList.onChange({ value: qnaIdx });
      setQnaExpandListData(draft => [...draft, qnaDetail]);
    }
  }, [fetchQnaDetailSuccess]);

  useDidUpdateEffect(() => {
    if (completeUpdateQnaSuccess) {
      // console.log('qnaDetail _____ ', qnaDetail, ' ---------- [ ', qnaIdx);
      SupportActions.fetch_qna_list_request({ page: qnaPage.value });
      initQnaData();
    }
  }, [completeUpdateQnaSuccess]);

  const handleClickSupportTab = (tabIndex: number | any) => {
    setMySupportTab(tabIndex);
  };

  const initQnaData = () => {
    requestTitle.setValue('');
    requestContent.setValue('');
    localFileList.setValue([]);
    setIsSubmit(false);
  };
  const handleInputAddLocalFile = (e: any) => {
    const {
      target: { files },
    } = e;

    // 10485760Bytes ==> 10MB
    const fileList = Object.keys(files).reduce((acc, key) => {
      files[key].id = moment() + uuid();
      if (
        files[key].size > 10485760 ||
        files[key].type.split('/')[0] !== 'image' ||
        files[key].name.split('.')[0].length > 124
      ) {
        files[key].isAbled = false;
      } else {
        files[key].isAbled = true;
      }
      return acc.concat(files[key]);
    }, []);

    localFileList.setValue((draft: any) => draft.concat(fileList));
  };

  useDidUpdateEffect(() => {
    if (isLast) {
      let submitData = {};
      if (uploadAbleFileLength !== uploadFileSuccessList.length) {
        // QnA 등록 실패
        submitData = {
          qnaIdx: updateQnaIdx,
          isSuccess: 0,
        };
      } else {
        // QnA 등록 성공 ->isScuccess 변경
        submitData = {
          qnaIdx: updateQnaIdx,
          isSuccess: 1,
        };
      }
      SupportActions.complete_update_qna_request(submitData);
    }
  }, [uploadFileSuccessList, isLast]);

  useDidUpdateEffect(() => {
    if (isFinishUploadLength === uploadAbleFileLength) {
      setIsLast(true);
    }
  }, [uploadAbleFileLength, isFinishUploadLength]);

  const handleDeleteLocalFile = (fileId: string) => {
    localFileList.setValue((draft: any) => draft.filter((item: any) => item.id !== fileId));
  };

  const handleSubmitQna = () => {
    // setExpand(false);
    const submitData = {
      title: requestTitle.value,
      content: requestContent.value,
      status: 0,
    };
    isExpand.onChange({ value: false });
    setIsSubmit(true);

    SupportActions.update_qna_request(submitData);
    // fileUpload(localFileList);
  };

  const fileUpload = useCallback((files: any, qnaIdx: number) => {
    if (files?.value?.length < 1) return;

    files.value.map(async (item: any, index: number) => {
      if (!item.isAbled) return;
      setUploadAbleFileLength(draft => draft + 1);
      try {
        const submitData = {
          qnaIdx,
          fileName: item.name,
          fileSize: item.size,
        };
        const resopnse = await fileApi.fetchQnaFileUploadUrl(submitData);
        if (resopnse.status === 200) {
          try {
            const signedUrl = resopnse.data.signedUrl;
            const cloudIdx = resopnse.data.cloudDataIdx;
            // const res = await axs({
            //   url: signedUrl,
            //   method: 'put',
            //   responseType: 'text',
            //   data: item,
            // });

            const res = await axios({
              url: signedUrl,
              method: 'put',
              // responseType: 'text',
              data: item,
            });
            if (res.status === 200) {
              setUploadFileSuccessList(draft => [...draft, cloudIdx]);
              setUploadSuccessIndexList(draft => [...draft, item.id]);
            }
          } catch (error) {
            AppActions.show_toast({
              type: 'error',
              message: (error as { message: string })?.message,
            });
          } finally {
            setIsFinishUploadLength(draft => draft + 1);
            // console.log('file upload finish');
          }
        }
      } catch (error) {
        AppActions.show_toast({ type: 'error', message: (error as { message: string })?.message });
      } finally {
        // console.log('file url finish');
      }
    });
  }, []);

  useDidUpdateEffect(() => {
    if (updateQnaSuccess) {
      // console.log('file length ______', localFileList.value.length);
      if (localFileList.value.length > 0) {
        fileUpload(localFileList, updateQnaIdx);
      } else {
        const submitData = {
          qnaIdx: updateQnaIdx,
          isSuccess: 1,
        };
        SupportActions.complete_update_qna_request(submitData);
        // localFileList;
      }
    }
  }, [updateQnaSuccess]);

  useEffect(() => {
    // init
    // SupportActions.
    if (mySupportTab) {
      SupportActions.fetch_qna_list_request({ page: qnaPage.value });
    } else {
      SupportActions.fetch_faq_list_request({
        page: faqPage.value,
        language: language.toUpperCase(),
      });
      // SupportActions.fetch_qna_list_request();
    }
    initQnaData();
  }, [mySupportTab]);

  const handleChangeFaqPage = (value: number) => {
    isExpand.onChange({ value: false });
    SupportActions.fetch_faq_list_request({ page: value, language: language.toUpperCase() });
    faqPage.setValue(value);
  };

  const handleChangeQnaPage = (value: number) => {
    isExpand.onChange({ value: false });
    SupportActions.fetch_qna_list_request({ page: value });
    qnaPage.setValue(value);
  };

  const handleDownloadFile = async (cloudDataIdx: number, fileName: string) => {
    try {
      const submitData = {
        cloudDataIdx,
      };
      const { data } = await fileApi.fetchQnaFileDownloadUrl(submitData);
      const { signedUrl } = data;
      downloadFile({
        url: signedUrl,
        name: fileName,
      });
    } catch (error) {
      AppActions.show_toast({ type: 'error', message: (error as { message: string })?.message });
    } finally {
      console.log('file download finish');
    }
  };

  return (
    <StyledSupport data-component-name="Support">
      <PageTitle title={t('NAV_MENU_SUPPORT')} />

      <div className="support__tabs_wrapper">
        {supportTabList.map((item: any, index: number) => {
          // 1:1QnA block
          if (item.idx === 1) return;
          return (
            <MuiWrapper className="support__tabs_btn_wrapper" key={index}>
              <MuiButton
                config={{
                  width: '200px',
                  height: '45px',
                }}
                disableElevation
                className={cx('support__tabs_btn', {
                  selected: mySupportTab === item.idx,
                })}
                variant="outlined"
                onClick={() => {
                  handleClickSupportTab(item.idx);
                }}
              >
                <CustomSpan fontSize={20} fontWeight={400}>
                  {item.title}
                </CustomSpan>
              </MuiButton>
            </MuiWrapper>
          );
        })}
      </div>
      {mySupportTab === 0 && (
        <section className="support__content_wrapper faq">
          <div>
            <div className="support__content_title_box">
              <div className="support__content_title">
                <h1>
                  <T>FAQ</T>
                </h1>
              </div>
            </div>
            <div className="support__table faq">
              <div className="support__table_head faq">
                <Grid container className="support__table_row">
                  <Grid item className="support__table_row_item">
                    <CustomSpan fontColor="#B5B7C1">
                      <T>GLOBAL_NUM</T>
                    </CustomSpan>
                  </Grid>
                  <Grid item className="support__table_row_item">
                    <T>GLOBAL_TITLE</T>
                  </Grid>
                </Grid>
              </div>
              <div className="support__table_body faq">
                {faqList?.map((item: any, index: number) => {
                  const detail = faqExpandListData.find((i: any) => i.faqIdx === item.faqIdx);
                  return (
                    <SupportListRow
                      key={index}
                      item={item}
                      isExpand={isExpand}
                      type={'faq'}
                      index={index}
                      detail={detail}
                      onExpandData={handleExpandData}
                      onDownloadFile={handleDownloadFile}
                    />
                  );
                })}
              </div>
            </div>
          </div>

          <div className="support__content_paging">
            {/* <MuiPagination
              config={{
                justifyContent: 'center',
              }}
              // count={Math.floor(faqPagingData?.totalPage)}
              count={faqPagingData?.totalPage}
              page={faqPage.value}
              onChange={(e: any, value: number) => {
                // faqPage.setValue(value);
                handleChangeFaqPage(value);
              }}
            /> */}
            {!!faqPagingData?.totalPage && (
              <CustomPagination
                totalPage={faqPagingData?.totalPage}
                currPage={faqPage.value}
                onChange={handleChangeFaqPage}
              />
            )}
          </div>
        </section>
      )}
      {mySupportTab === 1 && (
        <section className="support__content_wrapper qna">
          <h1 className="sr-only">1:1QnA</h1>
          <div className="support__qan_list_wrapper">
            <div className="support__table qna">
              <div className="support__table_head qna">
                <Grid container className="support__table_row">
                  <Grid item className="support__table_row_item">
                    <CustomSpan fontColor="#B5B7C1">
                      <T>GLOBAL_NUM</T>
                    </CustomSpan>
                  </Grid>
                  <Grid item className="support__table_row_item">
                    <T>GLOBAL_TITLE</T>
                  </Grid>
                </Grid>
              </div>
              <div className="support__table_body qna">
                {qnaList?.map((item: any, index: number) => {
                  const detail = qnaExpandListData.find((i: any) => i.qnaIdx === item.qnaIdx);
                  return (
                    <SupportListRow
                      key={index}
                      item={item}
                      isExpand={isExpand}
                      type={'qna'}
                      index={index}
                      detail={detail}
                      onExpandData={handleExpandData}
                      onDownloadFile={handleDownloadFile}
                    />
                  );
                })}
              </div>
            </div>

            <div className="support__content_paging">
              {/* <MuiPagination
                config={{
                  justifyContent: 'center',
                }}
                // count={Math.floor(faqPagingData?.totalPage)}
                count={qnaPagingData?.totalPage}
                page={qnaPage.value}
                onChange={(e: any, value: number) => {
                  // faqPage.setValue(value);
                  handleChangeQnaPage(value);
                }}
              /> */}
              {!!faqPagingData?.totalPage && (
                <CustomPagination
                  totalPage={faqPagingData?.totalPage}
                  currPage={qnaPage.value}
                  onChange={handleChangeQnaPage}
                />
              )}
            </div>
          </div>
          <div className="support__question_input_wrapper">
            <div className="support__question_input_box">
              <p>
                <CustomSpan fontSize={25} fontWeight={800} fontColor="#00A4E3">
                  {/* <T>1:1 Question</T> */}
                  1:1 Question
                </CustomSpan>
              </p>
              <Grid container className="support__question_input_row title">
                <Grid item className="support__question_input_label">
                  <span>
                    <T>GLOBAL_TITLE</T>
                  </span>
                </Grid>
                <Grid item className="support__question_input_content">
                  <MuiWrapper
                    className="support__input_wrapper"
                    config={
                      {
                        // borderColor: 'transparent',
                        // activeBorderColor: 'transparent',
                        // hoverBorderColor: 'transparent',
                      }
                    }
                  >
                    <TextField
                      className="radius-md support__input title"
                      variant="outlined"
                      fullWidth
                      placeholder="Fill in the title"
                      // error={!!errors.email}
                      // value={value.length > 1 ? value : value.trim()}
                      value={requestTitle.value}
                      onChange={e => {
                        // if (getStringByte(e.target.value) > 10) {
                        if (e.target.value.length > 120) {
                          return;
                        } else {
                          requestTitle.onChange(e);
                        }
                      }}
                      // inputRef={ref}
                    />
                  </MuiWrapper>
                </Grid>
              </Grid>
              <Grid container className="support__question_input_row message">
                <Grid item className="support__question_input_label">
                  <span>
                    <T>GLOBAL_MESSAGE</T>
                  </span>
                </Grid>
                <Grid item className="support__question_input_content">
                  <MuiWrapper className="support__input_wrapper">
                    <TextField
                      className="radius-md support__input message"
                      variant="outlined"
                      fullWidth
                      placeholder="Fill in the title"
                      multiline
                      rows={13}
                      value={requestContent.value}
                      onChange={e => {
                        // if (getStringByte(e.target.value) > 10) {
                        if (e.target.value.length > 5000) {
                          return;
                        } else {
                          requestContent.onChange(e);
                        }
                      }}
                    />
                  </MuiWrapper>
                </Grid>
              </Grid>
              <Grid container className="support__question_input_row file">
                <Grid item className="support__question_input_label ">
                  <span>
                    <T>ATTACHED_FILE</T>
                  </span>
                </Grid>
                <Grid item className="support__question_input_content">
                  <div className="support__file_upload_wrapper">
                    <label htmlFor="qnaImage" className="support__file_upload cursor-pointer">
                      <div>
                        <T>GLOBAL_ADD_FILE</T>
                      </div>
                    </label>
                    <input
                      type="file"
                      accept=".gif,.png,.jpeg,.jpg"
                      id="qnaImage"
                      // id="validBridgeData_5"
                      name="qnaImage"
                      hidden
                      ref={qnaFileRef}
                      multiple
                      onChange={e => {
                        handleInputAddLocalFile(e);
                        // e.target.value = '';
                      }}
                    />
                    <CustomSpan fontSize={11} fontWeight={400} fontColor="#17288A" marginLeft={10}>
                      <T>GLOBAL_IMAGE_UPLOAD_INFO</T>
                    </CustomSpan>
                  </div>
                  <div className="support__upload_file_list_wrapper">
                    {localFileList?.value.map((file: any, index: number) => {
                      const isProgressEnd = !!uploadSuccessIndexList.find(i => i === file.id);
                      return (
                        <div key={index} className="support__upload_file">
                          <span
                            className={cx('support__upload_file_text ', {
                              disable: !file.isAbled,
                            })}
                          >
                            {file.name}
                          </span>

                          <span>
                            {!file.isAbled && (
                              <>
                                <span className="support__upload_file_disabled">
                                  <T>CAN_NOT_SEND</T>
                                </span>
                                <span
                                  className="support__upload_file_cancel"
                                  onClick={e => {
                                    handleDeleteLocalFile(file.id);
                                  }}
                                >
                                  {'X'}
                                </span>
                              </>
                            )}
                            {!!file.isAbled && !isSubmit && (
                              <span
                                className="support__upload_file_cancel"
                                onClick={e => {
                                  handleDeleteLocalFile(file.id);
                                }}
                              >
                                {'X'}
                              </span>
                            )}{' '}
                            {!!file.isAbled && !!isSubmit && !isProgressEnd && (
                              <span>
                                <CircularProgress size={12} />
                              </span>
                            )}
                            {!!file.isAbled && !!isSubmit && !!isProgressEnd && <span></span>}
                          </span>
                        </div>
                      );
                    }, [])}
                  </div>
                </Grid>
              </Grid>
              <StyledNoneShadowButtonOuter height={56} left="50%" width={320}>
                <MuiButton
                  config={{
                    width: '280px',
                    color: color.navy_blue,
                    iconMarginAlign: 50,
                  }}
                  disabled={!requestTitle.value || !requestContent.value}
                  disableElevation
                  variant="contained"
                  onClick={handleSubmitQna}
                  className="xl border-radius-round inset-shadow-default projectInformation__next_btn"
                >
                  <T>GLOBAL_SUBMIT</T>
                </MuiButton>
              </StyledNoneShadowButtonOuter>
            </div>
          </div>
        </section>
      )}
    </StyledSupport>
  );
}

const StyledSupport = styled.section<{}>`
  padding-bottom: 30px;

  .support__tabs_wrapper {
    margin-top: 20px;
    margin-bottom: 30px;
    .support__tabs_btn_wrapper {
      height: 45px;
      margin-right: 10px;
      .support__tabs_btn {
        text-transform: none;
        color: #b5b7c1;
        &.selected {
          border: none;
          /* background: linear-gradient(to right, rgba(0, 166, 266, 1), rgba(8, 123, 238, 1)); */
          background-color: #00a6e2;
          color: #ffffff;
        }
      }
    }
  }

  .support__table {
    width: 100%;
    .support__table_row {
      .support__table_row_item {
        &:nth-child(1) {
          width: 90px;
          padding-left: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &:nth-child(2) {
          width: calc(100% - 90px);
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }
    .support__table_head {
      .support__table_row {
        width: 100%;
        height: 40px;
        border-radius: 5px;
        background-color: #f4f5fa;
        align-items: center;
        font-size: 15px;
        font-weight: 500;
      }
    }
    .support__table_body {
      .support__table_row {
        width: 100%;
        height: 100%;
        align-items: center;
        font-size: 13px;
        font-weight: 500;
        .support__table_row_item {
          height: 64px;
        }
      }
    }
  }

  .support__content_wrapper {
    background-color: #fff;
    .support__content_paging {
      padding: 50px 0;
    }
    &.faq {
      width: 100%;
      /* min-height: 800px; */
      min-height: 972px;
      border-radius: 15px;
      box-shadow: 0 0 10px rgb(0 0 0 / 16%);
      padding: 0 30px 0 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      /* position: relative; */
      .support__content_title_box {
        display: flex;
        /* padding: 40px 0 50px; */
        padding: 50px 0 25px;
        align-items: center;

        .support__content_title {
          h1 {
            line-height: 34px;
            font-size: 26px;
            font-weight: 500;
            color: #303030;
          }
        }
      }
    }
    &.qna {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      position: relative;
      .support__qan_list_wrapper {
        width: 806px;
        min-height: 800px;
        border-radius: 15px;
        box-shadow: 0 0 10px rgb(0 0 0 / 16%);
        padding: 40px 30px 0 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        z-index: 100;
        background-color: #ffffff;
      }
      .support__question_input_wrapper {
        width: calc(100% - 806px + 30px);
        margin-left: -30px;
        z-index: 1;
        .support__question_input_box {
          width: 100%;
          min-height: 750px;
          /* width: 806px; */
          border-radius: 15px;
          border: 1px solid #e7e8f2;
          position: relative;
          padding: 45px 60px 70px 90px;
          .support__question_input_row {
            align-items: flex-start;
            &.title {
              height: 40px;
              margin: 24px 0 10px;
            }
            &.message {
              height: 240px;
            }
            &.file {
              /* height: 278px; */
              height: 220px;
              margin: 15px 0 0;
              border-bottom: 1px dashed #b5b7c1;
            }
            .support__question_input_label {
              display: flex;
              align-items: center;
              width: 120px;
              height: 40px;
              font-size: 15px;
              font-weight: 500;
            }
            .support__question_input_content {
              width: calc(100% - 120px);
              .support__input_wrapper {
                width: 100%;
                .support__input {
                  height: 100%;
                  &.title {
                    height: 40px;
                  }
                  &.message {
                    height: 240px;
                  }
                }
              }
              .support__file_upload_wrapper {
                display: flex;
                align-items: center;
                height: 40px;
                .support__file_upload {
                  /* margin: 4px 0; */
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 20px;
                  height: 32px;
                  width: 150px;
                  background-color: ${color.navy_blue};
                  font-size: 13px;
                  font-weight: 500;
                  color: #ffffff;
                }
              }

              .support__upload_file_list_wrapper {
                /* width: 380px; */
                width: 450px;
                /* width: 370px; */
                /* margin-right: -10px; */
                height: 180px;
                overflow: overlay;
                padding-top: 10px;

                .support__upload_file {
                  /* width: 340px; */
                  /* width: 100%; */
                  /* height: 15px; */
                  height: 15px;
                  line-height: 20px;
                  padding: 4px 10px;
                  margin: 2px 15px 2px 0;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  /* margin: 4px 20px 4px 0; */
                  /* margin-right: 15px; */
                  font-size: 11px;
                  font-weight: 400;
                  .support__upload_file_text {
                    max-width: 350px;
                    height: 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    &.disable {
                      text-decoration: line-through;
                    }
                  }
                  .support__upload_file_disabled {
                    color: #eb0101;
                  }
                  .support__upload_file_cancel {
                    /* padding: 0 10px; */
                    font-size: 12px;
                    padding-left: 10px;
                    cursor: pointer;
                  }

                  &:hover {
                    background-color: #f4f5fa;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default React.memo(SupportContainer);
